import { HTMLAttributes } from 'react'
import { tv } from 'tailwind-variants'
import { cn } from '@scalis/utils'

type Variant = 'red' | 'yellow' | 'yellowgreen' | 'green'

export const matchScore = tv({
  base: 'flex w-12 h-6 items-center justify-center rounded-lg',
  variants: {
    color: {
      red: ['text-status-critical-10', 'bg-dataviz-cherry-red-05'],
      yellow: ['text-dataviz-soft-orange-50', 'bg-dataviz-soft-orange-05'],
      yellowgreen: ['text-dataviz-lime-green-50', 'bg-dataviz-lime-green-05'],
      green: ['text-dataviz-leaf-green-50', 'bg-dataviz-leaf-green-05'],
    },
  },
})

export const getVariant = (score: number): Variant => {
  if (score < 50) return 'red'
  if (score < 70) return 'yellow'
  if (score < 90) return 'yellowgreen'
  return 'green'
}

type MatchScoreProps = {
  score: number | null
} & HTMLAttributes<HTMLDivElement>

export const MatchScore = ({ score, className, ...rest }: MatchScoreProps) => {
  if (!score) return null
  const variant = getVariant(score)
  const displayScore = Math.round(score)

  return (
    <div
      className={cn(matchScore({ color: variant }), 'body-small-emphasis', className)}
      {...rest}
    >
      {displayScore}%
    </div>
  )
}
